// import store from '../store';
import data from '@/data/country_code.js'

export default {
    getBrowserLocales(options = {}) {
        const defaultOptions = {
            languageCodeOnly: false
        }

        const opt = {...defaultOptions, ...options}
        const browserLocales = navigator.languages === undefined ? [navigator.language] : navigator.languages

        if (!browserLocales) {
            return undefined
        }

        return browserLocales.map(locale => {
            const trimmedLocale = locale.trim()

            return opt.languageCodeOnly ? trimmedLocale.split(/-|_/)[0] : trimmedLocale;
        })
    },

    mapCountryToLang(country_code) {
        return (typeof data.countryToLanguageMapping[country_code] !== 'undefined')
            ? data.countryToLanguageMapping[country_code] : country_code
    },

    getIETFCountry(lang_country) {
        const arr_code = lang_country.split('-')
        const country_code = arr_code[1].toLowerCase()

        return (typeof data.countryToLanguageMapping[country_code] !== 'undefined')
            ? data.countryToLanguageMapping[country_code] : country_code
    },

    getLangList(lang_list) {
        return (typeof lang_list !== 'undefined') ?
            lang_list.map((x) => x.split('-')[1].toLowerCase()) : [];
    },

    buildIETFCountryLang(val) {
        return (typeof val !== 'undefined')
            ? `${this.mapCountryToLang(val)}-${val.toUpperCase()}` : ''
    }

}
